export const GET_SYSTEM_LOGS = 'GET_SYSTEM_LOGS'
export const GET_SYSTEM_REQUEST_LOGS = 'GET_SYSTEM_REQUEST_LOGS'
export const GET_SYSTEM_PROCESSES_LOGS = 'GET_SYSTEM_PROCESSES_LOGS'
export const GET_SYSTEM_LOGS_SUMMARY = 'GET_SYSTEM_LOGS_SUMMARY'
